import React from 'react';
import { useSettings } from '../contexts/SettingsContext';

export default function LoadingScreen({ message = 'Preparing your workspace...' }) {
  const { settings } = useSettings();
  return (
    <div className="loading-screen">
      <div className="loader-logo">{settings.logoUrl ? <img src={settings.logoUrl} alt="" /> : '🎓'}</div>
      <div className="loader-ring" />
      <strong>{settings.displayName || settings.platformName || 'Coaching Management'}</strong>
      <span>{message}</span>
    </div>
  );
}
